import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildTrainingMembershipsDataTableFilter,
  useTrainingMembershipsDataTable,
} from 'generated/resources/datatable.graphql'
import { TrainingClassFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const classFilter = (
  source: ReturnType<typeof useTrainingMembershipsDataTable>,
  trainingClasses: TrainingClassFragment[]
) => {
  const options = trainingClasses.map((traingingClass) => ({
    label: traingingClass.name || '',
    value: Number(traingingClass.id),
    component: (
      <Box>
        <Text size="300">{traingingClass.name}</Text>
      </Box>
    ),
  }))

  return buildTrainingMembershipsDataTableFilter(source, {
    identifier: 'class_filter',
    title: i18n.t('trainings.trainings_revamp.training_employee_table.filters.class_id'),
    path: 'classId',
    default: true,
    type: FilterType.Integer,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
  })
}
